import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { CurrentThemeStore } from '../../../stores/current-theme.store';

@Component({
    selector: 'app-external-links-page',
    templateUrl: './external-links-page.component.html',
    styleUrls: ['./external-links-page.component.scss'],
})
export class ExternalLinksPageComponent {
    @Input() shouldDisplayNavMenu = false;

    public items: MenuItem[] = [];

    constructor(readonly currentThemeStore: CurrentThemeStore) {
        this.loadExternalLinks();
    }

    private loadExternalLinks() {
        this.currentThemeStore.currentTheme$.subscribe(() => {
            this.items = [];
            if (this.currentThemeStore.currentTheme.externalLinks.length > 0) {
                this.currentThemeStore.currentTheme.externalLinks.forEach((link) => {
                    this.items.push({
                        label: link.name.slice(0, 20),
                        url: link.url,
                        target: '_blank',
                    });
                });
            }
        });
    }
}
